export default {
  locale: state => state.locale,
  userID: state => state.id,
  fullname: state => (state.firstname + ' ' + state.lastname).trim(),

  isParishioner: state => state.parishioner
}
